import { makeStyles } from 'makeStyles';
import { BACKGROUND_GREY, BLUE_BACKGROUND_WRAPPER, LIST_SELECTED, WHITE } from 'theme/colors';
import css from 'theme/themeV2';

export const useStyles = makeStyles()((theme) => ({
  actionsCell: {
    '@media (min-width: 700px)': {
      verticalAlign: 'middle',
      textAlign: 'end',
    },
  },
  activeRow: {
    backgroundColor: BLUE_BACKGROUND_WRAPPER,
  },
  clickable: {
    cursor: 'pointer',
  },
  editableTable: {
    width: 'fit-content',
    overflowX: 'auto',
    borderCollapse: 'separate',
    border: '1px solid rgba(224, 224, 224, 1)',

    '& th, td': {
      borderRight: '1px solid rgba(224, 224, 224, 1)',
    },
  },
  editableCell: {
    cursor: 'pointer',
    height: 40,
  },
  expanderCell: {
    background: BACKGROUND_GREY,
  },
  eventNameCell: {
    fontWeight: '400',
  },
  hoveredRow: {},
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  selected: {
    backgroundColor: LIST_SELECTED,
  },
  standardTable: {
    '& .MuiTableRow-head .MuiTableCell-root': {
      borderBottomWidth: '2px',
    },
    '& .MuiTableBody-root .MuiTableRow-root:last-of-type': {
      '& .MuiTableCell-root': {
        borderBottom: 'none',
      },
    },
    '& .MuiTableCell-root': {
      '@media (max-width: 700px)': {
        padding: '6px',
      },
      padding: '6px 20px 6px 6px',
    },
    '& .MuiTableCell-root:last-child': {
      padding: '6px 6px 6px 6px',
    },
  },
  tableContainer: {},
  '@media print': {
    tableContainer: {
      '& .MuiAccordion-root': {
        border: 'none',
      },
    },
    actionsRow: {
      display: 'none',
    },
    actionsCell: {
      display: 'none',
    },
  },
}));

export const actionsHeaderStyles = css({
  textAlign: 'end !important',
});

export const layerStyles = css({
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
});

export const responsiveRowStyles = css({
  '@media (max-width: 700px)': {
    display: 'grid',
    gridTemplateColumns: 'minmax(min-content, 1fr) minmax(min-content, 1fr)',
  },
  '@media (max-width: 500px)': {
    gridTemplateColumns: '1fr',
  },
});
export const responsiveHeaderCellStyles = css({
  textAlign: 'left',

  '@media (max-width: 700px)': {
    display: 'block',
    '&:not(:first-child)': {
      display: 'none',
    },
  },
});
export const responsiveCellStyles = css({
  '@media (max-width: 700px)': {
    display: 'block',
    '&:first-child': {
      backgroundColor: '$coreGreys5',
      gridColumn: '1 / -1',
    },
    '&[data-th]:before': {
      display: 'block',
      content: 'attr(data-th)',
      fontWeight: 'bold',
      placeSelf: 'start',
    },
  },
});

export const resizableHeaderCell = css({
  borderRight: '5px solid rgb(5,62,190)',
  borderRightStyle: 'solid',
});

export const editableCellStyles = css({
  '&:hover': {
    outline: 'solid',
    outlineOffset: '-1px',
    outlineColor: '#989ca7',
    outlineWidth: '1px',
    backgroundColor: '#f4f5f8',
  },
});

export const cellStyles = css({
  fontSize: '$semiMedium',
  lineHeight: 1.6,
  color: '$coreGreys100main',
  whiteSpace: 'nowrap',
});

export const pillStatusStyles = css({
  width: 'max-content',
});

export const stickyCellStyles = css({
  position: 'sticky',
  left: 0,
  zIndex: 1,
  backgroundColor: '$lightBg100Main',
  backgroundClip: 'padding-box',
  '@sm': {
    position: 'unset',
    left: 'unset',
    boxShadow: 'none',
  },
});

export const pinnedLeftStyles = css({
  position: 'sticky',
  left: 0,
  opacity: 1,
  background: WHITE,
  boxShadow: '-1px 0 1px -1px #888',
});

export const pinnedRightStyles = css({
  position: 'sticky',
  right: 0,
  opacity: 1,
  background: WHITE,
  boxShadow: '-1px 0 1px -1px #888',
});

export const expandedCellStyles = css({
  background: BACKGROUND_GREY,
});

export const resizerStyles = css({
  position: 'relative',
  top: 0,
  height: 30,
  width: 5,
  background: '#003EBE',
  cursor: 'col-resize',
  userSelect: 'none',
  touchAction: 'none',
  right: 0,
  opacity: 0,
});

export const selectedCellStyles = css({
  outline: 'solid',
  outlineOffset: '-1px',
  outlineColor: '#004dee',
  outlineWidth: '1px',
});

export const cellError = css({
  backgroundColor: '#fff',
  maxWidth: 'none',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '0px',
  fontSize: 14,
  color: '#323950',
  whiteSpace: 'nowrap',
  boxShadow: '0 0 15px  #dadce0',

  '& ul': {
    padding: '20px 16px',
  },
});
